<template>
	<section v-if="items.length" class="main-content contentblocks">
		<slot name="blocks-header" />
		<content-block
			v-for="item in items"
			:key="item.ID"
			:image="item.image"
			:image-webp="item.imageWebp ?? ''"
			:image-alt="item.imageAlt ?? ''"
			:header="item.header"
			:content="item.content"
			class="row contentblock"
		/>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--primary-background-color);

	:deep(h2) {
		margin: 0 auto 40px;
	}

	:deep(p) {
		margin: 40px auto;
		width: 70%;
		font-size: 18px;
		line-height: 34px;
	}
}

.contentblock {
	margin-bottom: 12px;

	:deep(h3) {
		font-size: 36px;
		line-height: 44px;
	}

	:deep(p) {
		margin: 40px auto;
		width: 100%;
		line-height: 44px;
	}

	:deep(.button) {
		line-height: 36px;
	}
}

@media (max-width: 1480px) {
	.contentblocks {
		:deep(h2) {
			font-size: 36px;
		}

		:deep(p) {
			font-size: 16px;
			line-height: 34px;
		}

		:deep(h2.subtitle) {
			font-size: 16px !important;
		}
	}
}

@media (max-width: 1080px) {
	.contentblocks {
		padding: 50px 15px;
	}

	.contentblocks .row {
		max-width: 700px;
	}
}

@media (max-width: 880px) {
	.contentblocks {
		:deep(h2) {
			font-size: 32px;
		}

		:deep(p) {
			font-size: 16px;
			line-height: 30px;
		}

		:deep(h2.subtitle) {
			font-size: 16px !important;
		}
	}

	.contentblocks .row:first-child {
		margin-top: 0;
	}

	.contentblocks .row:last-child {
		margin-bottom: 0;
	}

	.contentblock {
		margin-bottom: 12px;

		:deep(h3) {
			font-size: 32px;
			line-height: 44px;
		}

		:deep(p) {
			margin: 40px auto;
			width: 100%;
			line-height: 28px;
		}

		:deep(.button) {
			line-height: 28px;
		}
	}
}
</style>
